import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/style/main.scss";
import headercomponent from "./components/Header/header.component.vue";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import loadercomponent from "./components/Loader/loader.component.vue";
import imagePreviewPlugin from "./plugins/imagePreview";

Vue.config.productionTip = false;

Vue.component("loadercomponent",loadercomponent);
Vue.component("headercomponent", headercomponent);

Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(imagePreviewPlugin);

async function hardReloadIfNewBuildDetected() {
  const currentVersion = process.env.VUE_APP_VERSION || "0.0.0";
  const storageKey = "roomround_app_version";

  let previousVersion = null;
  try {
    previousVersion = localStorage.getItem(storageKey);
  } catch (e) {
    previousVersion = null;
  }

  if (!previousVersion) {
    try {
      localStorage.setItem(storageKey, currentVersion);
    } catch (e) {}
    return false;
  }

  if (previousVersion === currentVersion) return false;

  try {
    localStorage.setItem(storageKey, currentVersion);
  } catch (e) {}

  try {
    if (typeof caches !== "undefined" && caches && caches.keys) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (e) {}

  try {
    if (navigator && navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (e) {}

  try {
    window.location.reload(true);
  } catch (e) {
    window.location.reload();
  }

  return true;
}

// Global directive: v-animate
// Usage examples:
// <div v-animate>             // default fade-up
// <div v-animate="{ name: 'fade-in', delay: 120 }">
// <div v-animate="{ name: 'slide-left' }">
Vue.directive("animate", {
  inserted(el, binding) {
    const opts = binding.value || {};
    const name = opts.name || "fade-up";
    const delay = typeof opts.delay === "number" ? `${opts.delay}ms` : null;

    el.classList.add("anim-init");

    const onIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (delay) {
            el.style.animationDelay = delay;
          }
          el.classList.add(`anim-${name}`);
          el.classList.remove("anim-init");
          observer.unobserve(el);
        }
      });
    };

    const observer = new IntersectionObserver(onIntersect, {
      threshold: 0.12,
    });
    observer.observe(el);
  },
});

import { migrateAuthFromLocalStorage } from "@/utils/authStorage";

(async () => {
  migrateAuthFromLocalStorage();
  const reloading = await hardReloadIfNewBuildDetected();
  if (reloading) return;

  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
})();
